import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AppService } from '../_services/app.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard  {

  constructor(private dialog: MatDialog, private service: AppService, private router: Router) { }

  // Changed the default code to this for wait(avoid executing the next line) until gets the result.
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.service.currentUser === undefined) {
      return new Promise((resolve, reject) => {
        this.service.CheckAuth().then(e => {
          if (e) {
            resolve(true);
          } else {
            this.router.navigate(['login']);
            resolve(false);
          }
        });
      });
    } else if (this.service.currentUser.isAuthenticated === true) {
      return true;
    } else {
      return new Promise((resolve, reject) => {
        this.service.CheckAuth().then(e => {
          if (e) {
            resolve(true);
          } else {
            this.router.navigate(['login']);
            resolve(false);
          }
        });
      });
    }
  }
}
